import React, { useState } from 'react';
import Modal from 'react-modal';
const modalStyle = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    top: '50%',
    backgroundColor: "#f4effa",
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '50px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '300px'
  },
};

const WriterModal = ({ isOpen, closeModal, heading, content}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [checkCount, setCheckCount] = useState(0);
  const numCheck = 4;
  const handleNextStep = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };
  const handleNextStepCheckList = () => {
    if(checkCount < numCheck){
        alert("Please check all options");
        return;
    }
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleCheckBox = (event) =>{
    if(event.target.checked){
      setCheckCount((prevCount) => prevCount + 1);
    }
  }  
  const handlePreviousStep = () => {
    setCurrentStep((prevStep) => Math.max(prevStep - 1, 1));
  };

  const handleComplete = () => {
    // Add logic for completing the multi-step process
    closeModal();
  };

  const renderContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Welcome to your Writing Session!</h2>
            
            <button className = "form-submit-button" id ="modal-button" onClick={handleNextStep}>Next</button>
          </div>
        );
      case 4:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Type these commands for added support!</h2>
            <p><strong>/focus</strong>: This will take you to full screen mode and reduce distraction</p>
            
            
            <div className='modal-buttons'>
            <button className = "form-submit-button" id ="modal-button"onClick={handlePreviousStep}>Previous</button>
            <button className = "form-submit-button" id ="modal-button"onClick={handleNextStep}>Next</button>
            </div>
          </div>
        );
      case 5:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Type these commands for added support!</h2>
            <p><strong>/prompt</strong>: Don't know what to write about today, ask for a prompt</p>
            <div className='modal-buttons'>
            <button className = "form-submit-button" id ="modal-button" onClick={handlePreviousStep}>Previous</button>
            <button className = "form-submit-button" id ="modal-button" onClick={handleNextStep}>Next</button>
            </div>
          </div>
        );
        case 6:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Type these commands for added support!</h2>
            <p><strong>/motivate</strong>: Feeling low and in doubt, lets talk about it!</p>
            <div className='modal-buttons'>
            <button className = "form-submit-button" id ="modal-button" onClick={handlePreviousStep}>Previous</button>
            <button className = "form-submit-button" id ="modal-button" onClick={handleNextStep}>Next</button>
            </div>
          </div>
        );
        case 7:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Type these commands for added support!</h2>
            <p><strong>/inspire</strong>: Need a little inspiration, get works of great writers such as yourself to get you moving.</p>
            <div className='modal-buttons'>
            <button className = "form-submit-button" id ="modal-button" onClick={handlePreviousStep}>Previous</button>
            <button className = "form-submit-button" id ="modal-button" onClick={handleNextStep}>Next</button>
            </div>
          </div>
        );
        case 8:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Let's set up your writing space</h2>
            <ul>
              <li className='listItem'>Make sure your phone is switched off or away from you</li>
              <li className='listItem'>Keep some thing to eat and drink next to you</li>
              <li className='listItem'>Close all the tabs on your browser that you do not need</li>
              <li className='listItem'>Make sure you are in a comfortable setting with minimum distractions</li>
            </ul>
            <div className='modal-buttons'>
            <button className = "form-submit-button" id ="modal-button" onClick={handlePreviousStep}>Previous</button>
            <button className = "form-submit-button" id ="modal-button" onClick={handleNextStep}>Next</button>
            </div>
          </div>
        );
        case 2:
          return (
            <div className='modal-content'>
              <h2 className='modal-header'>Let's set up your writing space</h2>
              <div>
              <input type ="checkbox" className='listItem' onChange={handleCheckBox}/><label id ='writing-space-checklist-item'>Make sure your phone is switched off or away from you.</label><br></br>
              <input type ="checkbox" className='listItem' onChange={handleCheckBox}/><label id ='writing-space-checklist-item'>Keep some thing to eat and drink next to you.</label><br></br>
              <input type ="checkbox" className='listItem' onChange={handleCheckBox}/><label id ='writing-space-checklist-item'>Close all the tabs on your browser that you do not need.</label><br></br>
              <input type ="checkbox" className='listItem' onChange={handleCheckBox}/><label id ='writing-space-checklist-item'>Make sure you are in a comfortable setting with minimum distractions.</label><br></br>
              </div>
              <div className='modal-buttons'>
              <button className = "form-submit-button" id ="modal-button" onClick={handlePreviousStep}>Previous</button>
              <button className = "form-submit-button" id ="modal-button" onClick={handleNextStepCheckList}>I am ready</button>
              </div>
            </div>
          );
        case 3:
        return (
          <div className='modal-content'>
            <h2 className='modal-header'>Remember</h2>
            <p>You have decided to write for {localStorage.getItem("time")} mins</p>
            <p>Even if you are unable to write for this long, please wait until your time is up to leave your writing session. You have a clock on the right hand corner. Happy Writing!</p>
            <div className='modal-buttons'>
            <button className = "form-submit-button" id ="modal-button" onClick={handlePreviousStep}>Previous</button>
            <button className = "form-submit-button" id ="modal-button" onClick={handleComplete}>Begin</button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style = {modalStyle}
    >
      <div className='modal-content'> 
          {renderContent()}
      </div>
    </Modal>
  );
};

export default WriterModal;
